<template>
  <div class="sidebar">
    <v-logo v-if="windowWidth >= 992"/>
    <v-cart v-if="windowWidth >= 992"/>
    <div class="sidebar__inner">
      <v-canvas :maxHeight="height"/>
    </div>
  </div>
</template>



<script>
import { mapState } from 'vuex'

export default {
  components: {
    'v-logo': require('@/components/logo.vue').default,
    'v-cart': require('@/components/cart.vue').default,
    'v-canvas': require('@/components/canvas.vue').default,
  },
  computed: {
    ...mapState({
      windowWidth: state => state.window.width,
    }),
  },
  data() {
    return {
      height: false,
    }
  },
  watch: {
    windowWidth(val) {
      if (this.windowWidth >= 992) {
        this.height = 'auto'
      } else if (this.windowWidth >= 768) {
        this.height = 192 + 'px'
      } else {
        this.height = 128 + 'px'
      }
    },
  },
  mounted() {
    if (this.windowWidth >= 992) {
      this.height = 'auto'
    } else if (this.windowWidth >= 768) {
      this.height = 192 + 'px'
    } else {
      this.height = 128 + 'px'
    }
  }
}
</script>



<style lang="scss">
.sidebar {
  position: fixed;
  top: 42px;
  left: 0;
  z-index: map-get($z-index, sidebar);
  overflow: visible;
  box-shadow: 0 0 8px rgba(#000, 0.2);
  background: url(/choice/img/common/page-bg.png) center;
  width: 100%;
  padding: 0;
  @include breakpoints-min(md) {
  }
  @include breakpoints-min(lg) {
    position: fixed;
    top: 0;
    z-index: map-get($z-index, sidebar);
    overflow: hidden;
    box-shadow: none;
    background: transparent;
    width: $sidebar-width;
    height: 100%;
    padding-right: $sidebar-radius-width;
  }
  &:before {
    content: "";
    display: none;
    position: absolute;
    top: -20%;
    right: 0;
    z-index: map-get($z-index, sidebar) + 1;
    background: url(/choice/img/common/page-bg.png) center;
    border-radius: 50%;
    width: $sidebar-radius-width * 2;
    height: 140%;
    @include breakpoints-min(lg) {
      display: block;
    }
  }
  &__inner {
    @include breakpoints-min(lg) {
      z-index: map-get($z-index, sidebar) + 1;
      background: url(/choice/img/common/page-bg.png) center;
      height: 100%;
    }
  }

  .logo {
    @include breakpoints-min(lg) {
      position: absolute;
      z-index: map-get($z-index, sidebar) + 3;
      top: 20px;
      left: 28px;
    }
  }
  .cart {
    @include breakpoints-min(lg) {
      position: absolute;
      z-index: map-get($z-index, sidebar) + 4;
      bottom: 20px;
      left: 14px;
    }
  }
  .canvas {
    @include breakpoints-min(lg) {
      position: absolute;
      z-index: map-get($z-index, sidebar) + 2;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 90%;
      max-width: 600px;
    }
  }
}

.page-step-gogatsu .sidebar {
    /*background: #cfb8e6;*/
    background: url(/choice/img/common/page-bg-gogatsu.png) center;
    /*background-image: linear-gradient(45deg, #f2e6ff 25%, transparent 0),*/
    /*linear-gradient(45deg, transparent 75%, #f2e6ff 0),*/
    /*linear-gradient(45deg, #f2e6ff 25%, transparent 0),*/
    /*linear-gradient(45deg, #ffffff 75%, #f2e6ff 0);*/
    /*background-size: 18px 18px;*/
    /*background-position: 0 0, 9px 9px,*/
    /*9px 9px, 18px 18px;*/
    /*&:after {*/
        /*content: "";*/
        /*display: block;*/
        /*width: 100%;*/
        /*height: 100%;*/
        /*background: linear-gradient(200deg,transparent 2%,rgba(207,184,230,.2) 6%,rgba(207,184,230,.7) 22%,#cfb8e6 62%);*/
        /**/
        /*position: absolute;*/
        /*top: 0;*/
        /*left: 0;*/
    /*}*/
    
    @include breakpoints-min(lg) {
        background: transparent;
        &:after {
            background: transparent;
        }
    }
    
    &:before {
        background: url(/choice/img/common/page-bg-gogatsu.png) center;
        /*background: #cfb8e6;*/
        border-radius: 0;
    }
    
    &__inner {
        @include breakpoints-min(lg) {
            background: url(/choice/img/common/page-bg-gogatsu.png) center;
            /*background: #cfb8e6;*/
        }
    }
    .canvas {
        img {
            z-index: 1;
        }
    }
    
}
</style>
